<template>
  <div v-if="!featureData.activeObj.id" class="m-1 m-md-3">
    <div class="desktop-upload-panel">
      <span>上傳的內容分辨率越高，在您的產品上看起來就越好。</span>
      <span>首選文件類型 (最大大小: 5 MB)</span>
      <span>對於圖形，推薦去背的PNG檔案類型，打印時表現的效果會更好。</span>
      <span>對於照片，我們推薦以下文件類型：</span>
      <div class="d-flex" style="border: 1px solid;">
        <span style="border-right: 1px solid; padding: 5px 10px;">.JPG</span>
        <span style="padding: 5px 10px;">.PNG</span>
      </div>
      <div
        id="drag-drop-area"
        @dragover.prevent="handleDragOver"
        @dragleave="handleDragLeave"
        @drop.prevent="handleDrop"
        @click="handleClick"
      >
        <input id="file-input" type="file" style="display: none;" @change="handleFileChange" accept=".jpg, .png">
        <div class="upload-area" v-if="!isDragging">
          <img :src="GetImageUrl('tools/upload.png')" alt="" width="50">
          拖放檔案到此或點擊上傳圖片
        </div>
        <div class="upload-area with-file" v-else>
          釋放上傳資料
        </div>
      </div>
      <span>您是否有上面未列出的文件類型？</span>
      <span>您可以聯繫客服發送給我們或上傳它，我們會對其進行審核，</span>
      <span>並在我們為您生產訂單之前安排專人與您聯繫！</span>
    </div>
    <div class="desktop" v-if="featureData.uploadFiles.length" style="margin-top: 2rem; text-align: start; font-weight: 600;">您最近上傳的內容:</div>
    <div class="upload-image-block" v-if="featureData.uploadFiles.length">
      <div class="upload-image-box" v-for="file in featureData.uploadFiles" :key="file.image_id" @click="reproduceImage(file)">
        <div :style="`background-image: url(${file.image_url});`"></div>
      </div>
    </div>
    <div class="mobile" style="width: 100%; border-top: 1px solid rgba(51, 51, 51, 0.26); padding-top: 6px;">
      <div class="d-flex justify-content-center">
        <button class="mobile-upload-btn" @click="handleClick">從你的裝置上傳檔案</button>
      </div>
    </div>
  </div>
  <div v-else>
    <div class="dl-panel-item">
        <span>常規定位</span>
        <div class="dl-panel-item__box dl-panel-item__box--hover dl-panel-item__box--right-margin" @click="handleAlignClick()">置中</div>
      </div>
      <div class="dl-panel-item">
        <span>規格</span>
        <div class="d-flex align-items-center gap-md-2 gap-1">
          <div class="d-flex align-items-center gap-2">
            寬度<input 
              class="dl-panel-item__box dl-panel-item__box--m-small" 
              inputmode="decimal"
              type="number" 
              step="0.1" 
              min="0" 
              v-model="featureData.activeObj.inputWidthCm"
              @focus="setFocusedInput"
              @blur="handleChangeSize('width', $event, true)"
              @keydown.enter="handleChangeSize('width', $event, false)"/>cm
          </div>
          <span style="font-size: 14px;">&ensp;x&ensp;</span>
          <div class="d-flex align-items-center gap-2">
            高度<input 
              class="dl-panel-item__box dl-panel-item__box--m-small" 
              inputmode="decimal"
              type="number" 
              step="0.1" 
              min="0" 
              v-model="featureData.activeObj.inputHeightCm"
              @focus="setFocusedInput"
              @blur="handleChangeSize('height', $event, true)"
              @keydown.enter="handleChangeSize('height', $event, false)"/>cm
          </div>
        </div>
      </div>
  </div>
</template>

<script setup>
import { ref } from 'vue'
import {GetImageUrl} from "~/javascripts/utils.js";
import { featureData, setFeatureData, handleUpload, handleAlignClick, changeFabricImageSize, setFocusedInput, clearFocusedInput } from "~/vues/utils/feature.js"

const isDragging = ref(false);

// 監聽拖曳事件
const handleDragOver = () => {
  isDragging.value = true;
};

const handleDragLeave = () => {
  isDragging.value = false;
};

const handleDrop = (event) => {
  isDragging.value = false;
  // 取得拖曳的檔案
  const file = event.dataTransfer.files[0];
  // 處理上傳檔案的邏輯
  handleUpload(file);

  event.dataTransfer.value = '';
};

const handleClick = () => {
  // 觸發檔案上傳的 input 元素的點擊事件
  const fileInput = document.getElementById('file-input');
  if (fileInput) {
    fileInput.click();
  }
};

const handleFileChange = (event) => {
  const file = event.target.files[0];
  // 處理上傳檔案的邏輯
  handleUpload(file);

  event.target.value = '';
};

const reproduceImage = (file) => {
  setFeatureData('uploadObj', Object.assign(file, {design_type: 'image'}))
} 

const handleChangeSize = (side, event, isClear = false) => {console.log(event.target.value)
  const value = (Math.floor(event.target.value * 10) / 10); // 這邊輸入的值無條件捨去到小數第一位
  if(isClear) clearFocusedInput(event);
  
  if(featureData.activeObj.design_type == "image") changeFabricImageSize(side, value);
}

</script>